export default __webpack_public_path__ + "static/media/codigoIndicacao.793f90a2.png";